export default "__VITE_ASSET__FRZIaj1R__"